import {isNil} from 'ramda';

import {PriceReportType} from '../../../../../types/PriceReportType';
import {getVehiclePriceChangeDirection} from '../../../../../utils/getVehiclePriceChangeDirection';
import {ExtendedStatisticsCar} from '../types/ExtendedStatisticsCar';

export function getScatterPriceChangeDirection(
  car: ExtendedStatisticsCar | undefined,
  priceReport: PriceReportType,
  isHighlightEnabled: boolean
) {
  if (!isHighlightEnabled || isNil(car)) {
    return null;
  }

  return getVehiclePriceChangeDirection(car, priceReport);
}
